(function () {
    const queryAll = (selector, ctx = document) => ctx.querySelectorAll(selector);
    const event = new InputEvent('input');

    // Standardtext für den Clear-Button
    let clearButtonText = 'Clear input';

    const init = (options = {}) => {
        if (options.clearButtonText) {
            clearButtonText = options.clearButtonText;
        }
        handle_inputs();
    };

    const handle_inputs = () => {
        const input_fields = queryAll('input[data-clearable]:not([data-clearer-added="true"])');
        input_fields.forEach(input => {
            input.setAttribute('data-clearer-added', 'true');
            let button = document.createElement('button');
            button.classList.add('icon-clearer');
            button.setAttribute('data-clearer', 'true');
            button.setAttribute('aria-label', clearButtonText); // Nutze den Text für aria-label
            button.setAttribute('aria-controls', input.id);
            button.setAttribute( 'type', 'button' );

            button.addEventListener('click', (e) => {
                input.value = "";
                input.focus();
                input.dispatchEvent(event);
                e.preventDefault();
            });

            let icon = document.createElement('i');
            icon.classList.add('fa-solid', 'fa-circle-xmark');

            button.appendChild(icon);
            input.after(button);
        });
    };

    document.addEventListener('DOMContentLoaded', () => handle_inputs());
    document.addEventListener('htmx:afterOnLoad', () => handle_inputs());

    window.clearInputHandler = {
        init: init
    };
})();
